import { gql } from '@apollo/client';

export const getBrandClubForBrandPublic = gql`
  query getBrandClubForBrandPublic($brandId: Float!) {
    BrandClubForBrandPublic(brandId: $brandId) {
      campaignRewards
      availableSurveyRewardAmount
      availableContentRewardAmount
    }
  }
`;

export const searchBrandClubsForUserV2 = gql`
  query searchBrandClubsForUserV2(
    $titleInclude: [String!]
    $titleExclude: [String!]
    $brandIds: [Float!]
    $page: PageFilter!
    $clubsWithRewardOnly: Boolean
    $searchIntent: String
  ) {
    SearchBrandClubsForUserV2(
      titleInclude: $titleInclude
      titleExclude: $titleExclude
      brandIds: $brandIds
      page: $page
      clubsWithRewardOnly: $clubsWithRewardOnly
      searchIntent: $searchIntent
    ) {
      items {
        hasRewards
        totalRewardAmount
        campaignRewards
        brandclubId
        imageUrl
        name
        isMember
        brandId
        expiringRewardAmount
        rewardAmount
      }
      hasMore
      nextPage
    }
  }
`;

export const getUnauthedSearchBrandClubs = gql`
  query getUnauthedSearchBrandClubs(
    $titleInclude: [String!]
    $titleExclude: [String!]
    $brandIds: [Float!]
    $page: PageFilter
    $clubsWithRewardOnly: Boolean
    $searchIntent: String
  ) {
    UnauthedSearchBrandClubs(
      titleInclude: $titleInclude
      titleExclude: $titleExclude
      brandIds: $brandIds
      page: $page
      clubsWithRewardOnly: $clubsWithRewardOnly
      searchIntent: $searchIntent
    ) {
      items {
        hasRewards
        totalRewardAmount
        campaignRewards
        brandclubId
        imageUrl
        name
        isMember
        brandId
        expiringRewardAmount
        rewardAmount
      }
      hasMore
      nextPage
    }
  }
`;
